import React from 'react';
import TextField from '@material-ui/core/TextField';
import ClearIconML from '@/components/ClearIconML/index';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import { useForm, Controller } from 'react-hook-form';
import { useIntl } from 'umi';
import SearchIcon from '@material-ui/icons/Search';
import ReplayIcon from '@material-ui/icons/Replay';
import { useTheme } from '@material-ui/core';
import {
  Box,
  FormControl,
  MenuItem,
  Select,
  InputLabel,
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import webStorage from '@/utils/storageManager';

import SearchGroupStyled from './SearchGroupStyled';

const SearchGroup = React.forwardRef((props) => {
  //关于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const { query } = props;
  const { handleSearch, restClick, searchRef } = props;
  const { code, title, status, type } = query;
  const theme = useTheme();
  const { handleSubmit, control, reset, setValue, watch, getValues } = useForm({
    defaultValues: {
      code,
      title,
      status,
      type,
    },
  });
  //礼品状态
  const ACTIVITY_POINTS_GIFT_STATUS =
    webStorage
      .get('DICTOBJ')
      ?.ACTIVITY_POINTS_GIFT_STATUS?.filter(
        (item) => item.dictCode !== 'UNENFORCED_VALID',
      ) || [];
  //礼品类别
  const ACTIVITY_POINTS_GIFT_TYPE =
    webStorage.get('DICTOBJ')?.ACTIVITY_POINTS_GIFT_TYPE?.map((item) => ({
      ...item,
      nameZh: item.nameZh === '实物' ? '实物邮寄' : item.nameZh,
    })) || [];

  // 每个输入框清除数据
  //置空输入框
  //礼品状态
  const handleClearStatus = () => {
    setValue('status', '');
  };

  //礼品类别
  const handleClearType = () => {
    setValue('type', '');
  };
  const watchStatus = watch('status');
  const watchType = watch('type');

  //点击搜素
  const handleSubmitSuccess = (submitData) => {
    const propsSubmitData = {
      ...submitData,
    };

    handleSearch && handleSearch(propsSubmitData);
  };
  //点击重置
  const handleRestClick = () => {
    const resetSearch = {
      code: '',
      title: '',
      status: '',
      type: '',
    };
    reset(resetSearch);
    restClick && restClick(resetSearch);
  };

  return (
    <SearchGroupStyled theme={theme}>
      <form onSubmit={handleSubmit(handleSubmitSuccess)}>
        <Box className="card-content">
          <Box className="left">
            <Box className="line">
              <Controller
                render={(rp) => (
                  <TextField
                    name="code"
                    variant="standard"
                    label="礼品code"
                    value={rp.value ?? ''}
                    onChange={(e) => {
                      setValue('code', e.target.value);
                      return rp.value;
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            className="clear-btn"
                            onClick={() => {
                              setValue('code', '');
                            }}
                            edge="end"
                          >
                            {code ? <ClearIcon className="clear-icon" /> : ''}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
                name="code"
                variant="standard"
                control={control}
                id="basic"
                className="input"
                defaultValue={''}
              />

              <Controller
                render={(rp) => (
                  <TextField
                    name="title"
                    control={control}
                    id="basic"
                    variant="standard"
                    className="input"
                    label={formatMessage({ id: 'item.gift.n01.lbl02' })}
                    defaultValue=""
                    value={rp.value ?? ''}
                    onChange={(e) => {
                      setValue('title', e.target.value);
                      return rp.value;
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            className="clear-btn"
                            onClick={() => {
                              setValue('title', '');
                            }}
                            edge="end"
                          >
                            {getValues('title') ? (
                              <ClearIcon className="clear-icon" />
                            ) : (
                              ''
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
                name="title"
                control={control}
                id="basic"
                variant="standard"
                className="input"
                defaultValue=""
              />
              <FormControl variant="standard" className="gender">
                <InputLabel>
                  {formatMessage({ id: 'item.gift.n01.rdo03' })}
                </InputLabel>
                <Controller
                  as={
                    <Select
                      className="select"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="start">
                            <IconButton
                              className="clear-btn"
                              onClick={() => reset('status', '')}
                              edge="end"
                            >
                              {/* {getValues().memberCode ? (
                              <ClearIcon className="clear-icon" />
                            ) : (
                              ''
                            )} */}
                              <ClearIcon className="clear-icon" />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    >
                      {ACTIVITY_POINTS_GIFT_STATUS &&
                        ACTIVITY_POINTS_GIFT_STATUS.map((item) => (
                          <MenuItem
                            key={item.dictCode}
                            value={item.dictCode}
                            name={item.dictCode}
                          >
                            {item.nameZh}
                          </MenuItem>
                        ))}
                    </Select>
                  }
                  label={formatMessage({ id: 'item.gift.n01.rdo03' })}
                  name="status"
                  variant="standard"
                  control={control}
                  defaultValue=""
                />
                <ClearIconML
                  handleClick={handleClearStatus}
                  clearValue={watchStatus}
                ></ClearIconML>
              </FormControl>
              <FormControl variant="standard" className="channel">
                <InputLabel>礼品类型</InputLabel>
                <Controller
                  as={
                    <Select className="select">
                      {ACTIVITY_POINTS_GIFT_TYPE.map((item) => (
                        <MenuItem
                          key={item.dictCode}
                          value={item.dictCode}
                          name={item.dictCode}
                        >
                          {item.nameZh}
                        </MenuItem>
                      ))}
                    </Select>
                  }
                  label="礼品类型"
                  variant="standard"
                  name="type"
                  defaultValue=""
                  control={control}
                />
                <ClearIconML
                  handleClick={handleClearType}
                  clearValue={watchType}
                ></ClearIconML>
              </FormControl>
            </Box>
          </Box>
          <Box className="button-group">
            <Button
              variant="contained"
              color="secondary"
              className="reset"
              onClick={handleRestClick}
              startIcon={<ReplayIcon sx={{ width: '16px', height: '16px' }} />}
            >
              {formatMessage({ id: 'comm.action.btn.06' })}
            </Button>

            <Button
              data-log={JSON.stringify({
                oid: 'btn_point_mall_gift_management_list_search',
                events: ['_ev'],
                params: {
                  initUrl: window.location.origin + window.location.pathname,
                },
              })}
              ref={searchRef}
              variant="contained"
              type="submit"
              className="search"
              startIcon={<SearchIcon sx={{ width: '16px', height: '16px' }} />}
            >
              {formatMessage({ id: 'comm.action.btn.01' })}
            </Button>
          </Box>
        </Box>
      </form>
    </SearchGroupStyled>
  );
});

export default SearchGroup;
